<template>
  <div class="login_bg auth-screen" :class="{ mfa_bg: isMultiFactorAuthScreen }">
    <div class="slantTriangle"></div>
    <div class="loginHeader">
      <div class="trapezium"></div>
    </div>
    <div class="text-center">
      <img class="thread-logo" :src="threadLogoUrl" />
    </div>
    <div class="container">
      <div class="card" v-if="!isMultiFactorAuthScreen">
        <div class="card-body">
          <h2 class="card-title">Sign In</h2>
          <awsCognitoLogin @goToMFAScreen="goToMFAScreen" v-if="awsCognitoAuthentication && awsCognitoAuthentication === true" />
          <legacyLogin @goToMFAScreen="goToMFAScreen" v-else />
        </div>
      </div>
      <div v-if="isMultiFactorAuthScreen">
        <mfaAuth :twoFactorInput="twoFactorResponse" />
      </div>
    </div>
    <div class="footer-login-page">
      <div class="footer-main">
        <span class="cookie-settings-text" @click="openManageCookieModal()">
          Cookie Preferences
        </span>
        <span class="footer-line"> | </span>
        <span class="privacy-policy-text">
          <router-link :to="{ name: 'privacy-policy' }" target="_blank">Privacy Policy</router-link>
        </span>
        <span class="footer-line"> | </span>
        <span class="copyrightTextColor">© {{ new Date().getFullYear() }} {{ copyrightName }}</span>
      </div>
    </div>
    <cookieSettingsModal ref="cookieSettingsModal" platformType="portal"> </cookieSettingsModal>
    <manageCookiesModal ref="manageCookiesModal" platformType="portal"></manageCookiesModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import legacyLogin from "@/components/auth/legacy-login";
import awsCognitoLogin from "@/components/auth/aws-cognito-login";
import { datadogRum } from "@datadog/browser-rum";
import mfaAuth from "@/components/auth/mfa-auth";
import cookieSettingsModal from "@/components/auth/cookie-settings.vue";
import * as authService from "@/components/services/auth-service";
import manageCookiesModal from "@/components/auth/manage-cookies.vue";
import localStorageService from "@/services/localStorage";

export default {
  name: "login",
  data() {
    return {
      threadLogoUrl: "https://marketing-image-production.s3.amazonaws.com/uploads/e1d51d2a1da71cd72398505a49a577db12e11426f4a63143818246352efd8c386c5d0da4cbb5b8e4a62f39ef7c55e5141833ba41993eb7dde7af19329f08be56.png",
      copyrightName: "THREAD",
      isMultiFactorAuthScreen: false,
      twoFactorResponse: {}
    };
  },
  computed: {
    ...mapGetters(["user", "token", "awsCognitoAuthentication", "multiFactorAuthEnabled"])
  },
  components: {
    legacyLogin,
    awsCognitoLogin,
    mfaAuth,
    cookieSettingsModal,
    manageCookiesModal
  },
  watch: {
    user(user) {
      if (user.id) {
        if (process.env.VUE_APP_DD_WEB_PORTAL_APP_ID && process.env.VUE_APP_DD_WEB_PORTAL_APP_ID != "") {
          datadogRum.setUser({ id: user.id });
        }
        this.redirect("id");
      }
    }
  },
  methods: {
    ...mapActions(["userLogout"]),
    redirect(id) {
      if (!this.user.onBoarding) {
        if (this.user.profileCompleted === true && this.user.otpVerified) {
          if (this.user.userRole === "SystemAdmin") {
            this.$router.push({
              name: "studies"
            });
          } else if (this.$route.query.redirectTo) {
            this.redirectTo(this.$route.query.redirectTo);
          } else {
            this.$router.push({
              name: "studies"
            });
          }
        } else {
          if (this.user && this.user.id) {
            this.$router.push({
              name: "aboutYou",
              params: {
                userId: this.user.id
              }
            });
          } else {
            localStorageService.removeAll();
            this.$router.push({
              name: "login"
            });
          }
        }
      } else if (this.$route.query.redirectTo) {
        this.redirectTo(this.$route.query.redirectTo);
      } else {
        this.$router.push({
          name: "studies"
        });
      }
      if (id) {
        this.$toastr.success("Successfully logged in");
      }
    },
    redirectTo(path) {
      let pattern = /^((http|https):\/\/)/;
      if (pattern.test(path)) {
        window.location.href = path;
      } else {
        this.$router.push(path);
      }
    },
    goToMFAScreen(response) {
      this.twoFactorResponse = response;
      window.localStorage.setItem("MFATokenDetails", JSON.stringify(response));
      this.isMultiFactorAuthScreen = true;
    },
    openCookieSettingsModal() {
      this.$refs.cookieSettingsModal.show();
    },
    checkCookiePreference() {
      let isCookiesAccepted = authService.getCookiePreference("portal");
      if (!isCookiesAccepted) {
        this.openCookieSettingsModal();
      }
    },
    openManageCookieModal() {
      this.$refs.manageCookiesModal.show();
    }
  },
  created() {
    if (this.multiFactorAuthEnabled) {
      let getMFAAuthDetails = JSON.parse(window.localStorage.getItem("MFATokenDetails"));
      if (getMFAAuthDetails && getMFAAuthDetails.twoFARequestId && getMFAAuthDetails.partialphoneNumber) {
        this.isMultiFactorAuthScreen = true;
      }
    }
  },
  mounted() {
    this.threadLogoUrl = "https://marketing-image-production.s3.amazonaws.com/uploads/e1d51d2a1da71cd72398505a49a577db12e11426f4a63143818246352efd8c386c5d0da4cbb5b8e4a62f39ef7c55e5141833ba41993eb7dde7af19329f08be56.png";
    if (this.$route.query.error) {
      this.formErrors = {
        message: this.$route.query.error
      };
    }
    if (this.token) {
      if (this.token.expires < new Date().getTime()) {
        this.userLogout();
      } else {
        this.redirect();
      }
    }
    this.checkCookiePreference();
  }
};
</script>

<style lang="scss" scoped>
.slantTriangle {
  position: absolute;
  transform: translate(-50%, -50%);
  height: 25%;
  width: 105%;
  border-bottom: 200vh solid rgba(169, 169, 169, 0.1);
  border-right: 70vh solid transparent;
}

.loginHeader {
  background-color: #b0bac9;
  width: 100%;
  height: 68px;
}

.trapezium {
  position: absolute;
  transform: translate(-50%, -50%);
  height: 5px;
  width: 35%;
  border-bottom: 135px solid #34537d;
  border-right: 100px solid transparent;
}

.footer-login-page {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 14px;
  background: #00365a;
}

.footer-main {
  position: relative;
  bottom: 40px;
  display: flex;
  float: right;
  margin-right: 40px;
}

.footer-line {
  color: #666669;
  position: relative;
  bottom: 2px;
  margin-left: 9px;
  margin-right: 6px;
}

.privacy-policy-text {
  color: #34537d;
  position: relative;
  font-size: 9px;
  font-weight: bold;
  top: 2px;

  a {
    color: #34537d !important;
    font-size: 9px;
  }
}

.thread-logo {
  width: 250px;
  height: 50px;
  margin: 0 auto;
  margin-top: 73px;
  margin-bottom: 43px;
}

.copyrightTextColor {
  color: #666669;
  font-weight: bold;
  font-size: 9px;
  position: relative;
  top: 2px;
}

@media only screen and (max-height: 578px) {
  .thread-logo {
    margin-top: 35px;
    margin-bottom: 20px;
  }
}

@media (min-width: 320px) and (max-width: 768px) {
  .footer-login-page {
    position: absolute !important;
    bottom: 0 !important;
    width: 100%;
    height: 14px;
    background: #00365a;
  }

  .footer-main {
    position: relative;
    bottom: 25px !important;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    float: right;
    margin-right: 25px !important;
  }
}

@media (max-height: 650px) {
  .auth-screen {
    background-color: #ffffff;
    background-size: cover;
    height: 648px !important;
    position: relative;
  }
}

@media (max-width: 1024px) {
  .login_bg {
    background-color: #ffffff;
    background-size: cover;
    height: 736px !important;
    min-height: 100vh;
    position: relative;
  }
}

@media (max-width: 640px) {
  .login_bg {
    background-color: #ffffff;
    background-size: cover;
    height: 640px;
    min-height: 100vh;
    position: relative;
  }
}

@media (max-width: 667px) {
  .login_bg {
    background-color: #ffffff;
    background-size: cover;
    height: 667px;
    min-height: 100vh;
    position: relative;
  }
}

@media (max-width: 736px) {
  .login_bg {
    background-color: #ffffff;
    background-size: cover;
    height: 736px;
    min-height: 100vh;
    position: relative;
  }
}
.mfa_bg {
  background-color: #ffffff;
  background-size: cover;
  min-height: 100vh;
  position: relative;
}

.cookie-settings-text {
  color: #5c8add;
  position: relative;
  font-size: 9px;
  font-weight: bold;
  top: 2px;
  cursor: pointer;
}
</style>
<style lang="scss" src="@/assets/auth-screen.scss"></style>
